import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming you have this in your configuration

const EditPurchaseOrder = () => {
    const { id } = useParams(); // Get the purchase order ID from the URL
    const navigate = useNavigate();

    // State to manage form fields
    const [formData, setFormData] = useState({
        pack_unit: '',
        pack_qty: '',
        unit: '',
        quantity: '',
        free_quantity: '',
        rate: '',
        amount: '',
        discount: '',
        tax_code: '',
        tax_rate: '',
        taxable: '',
        tax_amount: '',
        cess_rate: '',
        cess_amount: '',
        mrp: '',
        net_rate: '',
        remarks: '',
        item_barcode: '',
        req_vno: '',
        req_ref_no: '',
        req_ref_date: '',
        req_vdate: '',
        item_balance: '',
        barcode: '',
        line_level_barcode: '',
        lgst: '',
        cgst: '',
        sgst: '',
        hsn_code: '',
        brand: ''
    });

    // Fetch purchase order details on component mount
    useEffect(() => {
        fetch(`${BASE_URL}purcheshorder/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    setFormData(data.data); // Populate form with API response
                }
            })
            .catch((error) => console.error('Error fetching purchase order details:', error));
    }, [id]);

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        fetch(`${BASE_URL}purcheshorder/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    alert(data.message);
                    navigate('/PurchaseOrderList'); // Redirect to purchase orders list page
                } else {
                    alert('Error updating the purchase order. Please try again.');
                }
            })
            .catch((error) => console.error('Error updating purchase order:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Purchase Order</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {/* Render all form fields */}
                                    <div className="mb-3">
                                        <label htmlFor="pack_unit" className="form-label">Pack Unit</label>
                                        <input type="text" id="pack_unit" name="pack_unit" className="form-control" value={formData.pack_unit} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="pack_qty" className="form-label">Pack Quantity</label>
                                        <input type="number" id="pack_qty" name="pack_qty" className="form-control" value={formData.pack_qty} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="unit" className="form-label">Unit</label>
                                        <input type="text" id="unit" name="unit" className="form-control" value={formData.unit} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="quantity" className="form-label">Quantity</label>
                                        <input type="number" id="quantity" name="quantity" className="form-control" value={formData.quantity} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="free_quantity" className="form-label">Free Quantity</label>
                                        <input type="number" id="free_quantity" name="free_quantity" className="form-control" value={formData.free_quantity} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="rate" className="form-label">Rate</label>
                                        <input type="number" id="rate" name="rate" className="form-control" value={formData.rate} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input type="number" id="amount" name="amount" className="form-control" value={formData.amount} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="discount" className="form-label">Discount</label>
                                        <input type="number" id="discount" name="discount" className="form-control" value={formData.discount} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="tax_code" className="form-label">Tax Code</label>
                                        <input type="text" id="tax_code" name="tax_code" className="form-control" value={formData.tax_code} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="tax_rate" className="form-label">Tax Rate</label>
                                        <input type="number" id="tax_rate" name="tax_rate" className="form-control" value={formData.tax_rate} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="taxable" className="form-label">Taxable</label>
                                        <input type="number" id="taxable" name="taxable" className="form-control" value={formData.taxable} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="tax_amount" className="form-label">Tax Amount</label>
                                        <input type="number" id="tax_amount" name="tax_amount" className="form-control" value={formData.tax_amount} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="cess_rate" className="form-label">Cess Rate</label>
                                        <input type="number" id="cess_rate" name="cess_rate" className="form-control" value={formData.cess_rate} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="cess_amount" className="form-label">Cess Amount</label>
                                        <input type="number" id="cess_amount" name="cess_amount" className="form-control" value={formData.cess_amount} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="mrp" className="form-label">MRP</label>
                                        <input type="number" id="mrp" name="mrp" className="form-control" value={formData.mrp} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="net_rate" className="form-label">Net Rate</label>
                                        <input type="number" id="net_rate" name="net_rate" className="form-control" value={formData.net_rate} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="remarks" className="form-label">Remarks</label>
                                        <textarea id="remarks" name="remarks" className="form-control" value={formData.remarks} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="item_barcode" className="form-label">Item Barcode</label>
                                        <input type="text" id="item_barcode" name="item_barcode" className="form-control" value={formData.item_barcode} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="req_vno" className="form-label">Request Voucher Number</label>
                                        <input type="text" id="req_vno" name="req_vno" className="form-control" value={formData.req_vno} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="req_ref_no" className="form-label">Request Reference Number</label>
                                        <input type="text" id="req_ref_no" name="req_ref_no" className="form-control" value={formData.req_ref_no} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="req_ref_date" className="form-label">Request Reference Date</label>
                                        <input type="date" id="req_ref_date" name="req_ref_date" className="form-control" value={formData.req_ref_date} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="req_vdate" className="form-label">Request Voucher Date</label>
                                        <input type="date" id="req_vdate" name="req_vdate" className="form-control" value={formData.req_vdate} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="item_balance" className="form-label">Item Balance</label>
                                        <input type="number" id="item_balance" name="item_balance" className="form-control" value={formData.item_balance} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="barcode" className="form-label">Barcode</label>
                                        <input type="text" id="barcode" name="barcode" className="form-control" value={formData.barcode} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="line_level_barcode" className="form-label">Line Level Barcode</label>
                                        <input type="text" id="line_level_barcode" name="line_level_barcode" className="form-control" value={formData.line_level_barcode} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="lgst" className="form-label">LGST</label>
                                        <input type="number" id="lgst" name="lgst" className="form-control" value={formData.lgst} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="cgst" className="form-label">CGST</label>
                                        <input type="number" id="cgst" name="cgst" className="form-control" value={formData.cgst} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="sgst" className="form-label">SGST</label>
                                        <input type="number" id="sgst" name="sgst" className="form-control" value={formData.sgst} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="hsn_code" className="form-label">HSN Code</label>
                                        <input type="text" id="hsn_code" name="hsn_code" className="form-control" value={formData.hsn_code} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="brand" className="form-label">Brand</label>
                                        <input type="text" id="brand" name="brand" className="form-control" value={formData.brand} onChange={handleChange} />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Update Purchase Order
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditPurchaseOrder;
